import React, { Component } from 'react'
import { bindActionCreators } from 'redux'

import { connect } from 'react-redux'
import { Layout } from 'antd'
import { Route } from 'react-router-dom'

import { childRoutes } from '../../route'

import Header from '../../layouts/Header'
import Sidebar from '../../layouts/Sidebar'
import ContentAlert from '../../components/Notifications/content-alert'
import TransferIndicator from '../../components/ManagedTransfer/TransferIndicator'
import { refresh_profile, logout } from '../../actions/auth'
import Player from '../../components/VideoPlayer'

import './styles.scss'

const { Content } = Layout

class App extends Component {
    constructor() {
        super()

        this.state = {
            siderCollapsed: false,
            slack_open: false,
            slack_activated: false,
            slack_on_sidebar: false,
            slack_on_popup: false,

            alert_content: {
                message: '',
                button_text: 'Okay',
                notification_type: 'warning',
                on_click: null,
            },
        }
    }

    componentWillMount() {
        const { actions } = this.props
        actions.refresh_profile()
    }

    componentWillReceiveProps(props) {
        this.setState({ alert_content: props.contentAlert })
    }

    componentDidCatch(error, info) {
        this.setState({ has_error: true })
        console.error(error, info)
    }

    render() {
        const {
            auth,
            actions,
            fullHeight,
            component: Component,
            ...rest
        } = this.props
        const { message, button_text, on_click } = this.state.alert_content

        return (
            <Route
                {...rest}
                render={matchProps => (
                    <Layout className="ant-layout-has-sider">
                        {/* <Sidebar /> */}
                        <Layout>
                            <Header profile={auth} logout={actions.logout} />
                            <Content className="content_comp">
                                <ContentAlert
                                    message={message}
                                    button_text={button_text}
                                    on_click={on_click}
                                />
                                <div
                                    style={{
                                        minHeight: 360,
                                        height: fullHeight ? '100%' : 'auto',
                                    }}>
                                    <Component {...matchProps} />
                                </div>
                            </Content>
                            <Player float />
                            <TransferIndicator history={this.props.history} />
                        </Layout>
                    </Layout>
                )}
            />
        )
    }
}

const mapStateToProps = ({ auth, contentAlert }) => {
    return {
        auth: auth ? auth : null,
        contentAlert,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ refresh_profile, logout }, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)
